import { gsap } from 'gsap/gsap-core';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(CustomEase);

const InitHero = () => {
  setTimeout(() => {
    CustomEase.create(
      'waveEase',
      'M0,0 C0.25,0.1 0.25,1 0.5,1 C0.75,1 0.75,0 1,0'
    );
    document.querySelectorAll('.wave').forEach((el) => {
      const letters = el.textContent.split('');
      el.textContent = '';
      letters.forEach((char, i) => {
        const span = document.createElement('span');
        span.textContent = char;
        span.style.display = 'inline-block';
        span.style.color = '#fff';
        el.appendChild(span);

        gsap.to(span, {
          y: 5,
          color: '#DAE000',
          duration: 3,
          repeat: -1,
          yoyo: true,
          ease: 'waveEase',
          delay: i * 0.1,
        });
      });
    });
  }, 100);
};

export default InitHero;
